import { useCallback } from 'react';

import { Box, Button } from '@frontierag/frontier-ui-library';
import { Add as AddIcon, Remove as RemoveIcon } from '@frontierag/frontier-ui-library/icons';

import type { IQuantityControl } from './types';

export default function QuantityControl({
  quantity,
  minQuantity,
  maxQuantity,
  step = 1,
  testIdPrefix = 'quantity-control',
  onChange,
}: IQuantityControl) {
  const normalizeValue = useCallback((value: number) => Number(value.toFixed(3)), []);

  const handleIncrease = useCallback(
    () => onChange(normalizeValue(quantity + step)),
    [normalizeValue, onChange, quantity, step],
  );
  const handleDecrease = useCallback(
    () => onChange(normalizeValue(quantity - step)),
    [normalizeValue, onChange, quantity, step],
  );

  return (
    <Box display="flex" alignItems="center" gap={1} data-testid={testIdPrefix}>
      <Button
        color="primary"
        variant="contained"
        disabled={Boolean(minQuantity && quantity <= minQuantity)}
        onClick={handleDecrease}
        sx={{ width: 24, height: 24, minWidth: 'auto', p: 0 }}
        data-testid={`${testIdPrefix}-decrease`}
      >
        <RemoveIcon />
      </Button>
      <Box data-testid={`${testIdPrefix}-value`}>{quantity}</Box>
      <Button
        variant="contained"
        color="primary"
        disabled={Boolean(maxQuantity && quantity >= maxQuantity)}
        onClick={handleIncrease}
        sx={{ width: 24, height: 24, minWidth: 'auto', p: 0 }}
        data-testid={`${testIdPrefix}-increase`}
      >
        <AddIcon />
      </Button>
    </Box>
  );
}
